import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import CertificationEnquiryModal from "@/components/CertificationEnquiryModal";
import { InternshipHero } from "@/components/internship/InternshipHero";
import { CourseOverviewSection, AudienceSection, SkillsSection } from "@/components/internship/InternshipOverview";
import { CurriculumSection, LabsSection } from "@/components/internship/InternshipCurriculum";
import { ProjectsSection, TimelineSection, ToolsSection } from "@/components/internship/InternshipProjects";
import { CareersSection, FeaturesSection, LearningPathSection } from "@/components/internship/InternshipCareer";
import { CertificationSection, FaqSection, TestimonialsSection, FinalCtaSection } from "@/components/internship/InternshipCertFaq";

export { ELEARNING_COURSE_URL } from "@/data/certificationProgramData";

export default function SalesforceDataCloudInternshipPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [enquiryOpen, setEnquiryOpen] = useState(false);

  const openEnquiry = () => {
    if (loading) return;
    if (!user) {
      toast.info("Please create a free account first, then come back to enquire.");
      navigate("/register");
      return;
    }
    setEnquiryOpen(true);
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10" data-testid="certification-program-page">
      <button onClick={() => navigate(user ? "/dashboard" : "/")} data-testid="certification-back-home-link" className="flex items-center gap-1.5 text-sm text-slate-400 hover:text-white mb-6">
        <ArrowRight className="w-3.5 h-3.5 rotate-180" /> Back to Cloudivo
      </button>

      <InternshipHero onEnquiry={openEnquiry} />
      <CourseOverviewSection />
      <AudienceSection />
      <SkillsSection />
      <CurriculumSection />
      <LabsSection />
      <ProjectsSection />
      <TimelineSection />
      <ToolsSection />
      <CareersSection />
      <FeaturesSection />
      <LearningPathSection />
      <CertificationSection onEnquiry={openEnquiry} />
      <FaqSection />
      <TestimonialsSection />
      <FinalCtaSection onEnquiry={openEnquiry} />

      <CertificationEnquiryModal open={enquiryOpen} onClose={() => setEnquiryOpen(false)} />
    </div>
  );
}
